import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AccessDeniedPage, Spinner } from '@climatepartner/components';

import { useAuth } from './plugins/auth/AuthProvider';
import Homepage from './pages/Homepage';
import { Layout } from './components/Layout';
import { DecodedTokenWithServices } from './helpers/token';
import { extractUserServiceLinks, getAllRawEnabledServiceNames, sortServiceLinks } from './helpers/tokenUtils';
import { Box } from '@mui/material';

export const useServices = () => {
    const auth = useAuth();
    const userServiceLinks = () =>
        sortServiceLinks(extractUserServiceLinks(auth[0].decodedAccessToken as DecodedTokenWithServices));
    const userServices = getAllRawEnabledServiceNames(auth[0].decodedAccessToken);
    const hasAccessToReductionForms = userServices.includes('reduction-forms');
    return {
        auth,
        userServiceLinks,
        hasAccessToReductionForms,
    };
};

const AppRoutes = () => {
    const { auth, userServiceLinks, hasAccessToReductionForms } = useServices();
    const [{ user }] = auth;

    if (user === null) {
        return <Spinner isFixed />;
    }

    if (userServiceLinks().length === 0 && !hasAccessToReductionForms) {
        return (
            <Box mt={2}>
                <AccessDeniedPage />
            </Box>
        );
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route path="/" element={<Homepage auth={auth} userServiceLinks={userServiceLinks} />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;
